import React from 'react';

const Card = ({ label, value, chip, chipTone = 'text-[#008080]', note, highlight = false }) => (
  <li
    className={`min-w-0 rounded-2xl border p-4 shadow-sm ${
      highlight ? 'bg-gradient-to-br from-[#006666] to-[#008080] border-[#006666] text-white' : 'bg-white border-slate-200/90'
    }`}
  >
    <p className={`text-[10px] font-bold uppercase tracking-wider ${highlight ? 'text-teal-100' : 'text-slate-500'}`}>{label}</p>
    <div className="mt-1.5 flex flex-wrap items-baseline gap-x-2 gap-y-1">
      <span className={`text-2xl sm:text-[28px] font-extrabold tracking-tight ${highlight ? 'text-white' : 'text-slate-900'}`}>{value}</span>
      {chip && <span className={`text-[11px] font-bold ${highlight ? 'text-teal-100' : chipTone}`}>{chip}</span>}
    </div>
    <p className={`mt-1 text-[11px] truncate ${highlight ? 'text-teal-50/90' : 'text-slate-400'}`}>{note}</p>
  </li>
);

/** Headline counts for the SEBI filings page, from the de-duplicated rows. */
export const SebiStatCards = ({ stats, loading }) => {
  if (loading) {
    return (
      <ul className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" aria-busy="true">
        {Array.from({ length: 4 }).map((_, idx) => (
          <li key={idx} className="h-[104px] rounded-2xl border border-slate-200/90 bg-white shadow-sm animate-pulse" />
        ))}
      </ul>
    );
  }

  return (
    <ul className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <Card
        label="Filings Tracked"
        value={stats.total}
        chip={stats.addedThisWeek ? `+${stats.addedThisWeek} this week` : null}
        note="Companies with a DRHP or RHP on record"
      />
      <Card label="Under SEBI Review" value={stats.underReview} note="DRHP filed, awaiting observations" />
      <Card label="Approved · RHP Filed" value={stats.approved} note="SEBI observations received" />
      <Card label="Analysis Published" value={stats.analysed} note="Financials & risks extracted" highlight />
    </ul>
  );
};

export default SebiStatCards;
